import React, { useState, useEffect } from 'react';
import Modal                          from 'react-bootstrap/Modal';
import AuthService                    from 'services/auth.service';
import UserService                    from 'services/user.service';
import AssistantService               from 'services/assistant.service';

const SelectLocation = (props) => {
  const [show, setShow]                     = useState(true);
  const handleClose                         = () => setShow(false);
  const [panels, setPanels]                 = useState([]);
  const [location,setLocation]              = useState(null);
  const currentUser                         = AuthService.getCurrentUser();
  const practiceLocation                    = AuthService.getPracticeLocation();
  const [displayError, setDisplayError]     = useState(false);
  const currentAssistant                    = AuthService.getCurrentAssistant();
  const [locationIds, setLocationIds]       = useState([]);
  const [locationList, setLocationList]     = useState(null);

  const logOut = () => {
    AuthService.logout();
    window.location.replace('/eb/login');
  };

  useEffect(() => {
    if (!practiceLocation) { // This fixes -> Warning: Can't perform a React state update on an unmounted component. Note: expanding the error will show you which line of code the error is at.

      // For assistants, must get practice location ids then match with user service.
      if (currentAssistant) {
        AssistantService.profile(currentAssistant.id).then(
          (data) => {
            setLocationIds(data.practice_location_ids);
          },
          (error) => {
            if (error.response.status === 401) {
              AuthService.logout();
              window.location.replace('/eb/login');
            }
          }
        );
      }

      // Getting practice locations.
      UserService.profile(currentUser.id).then(
        (data) => {
          setLocationList(data.locations);
        },
        (error) => {
          if (error.response.status === 401) {
            AuthService.logout();
            window.location.replace('/eb/login');
          }
        }
      );
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  // Need useEffect, or the api will call non stop.

  useEffect(() => {
    let allowedLocations = locationList;
    if (allowedLocations === null) {
      return;
    }

    if (currentAssistant) {
      allowedLocations = locationList.filter((hash) => locationIds.includes(hash.id));
    }

    // 1 -> Select immediately, 0 -> Error message, Multiple -> Give selection choices.
    if (allowedLocations.length === 1) {
      setLocation(allowedLocations[0]);
    } else if (allowedLocations.length === 0) {
      setDisplayError(true);
    } else {
      setDisplayError(false);

      const panelLocations = allowedLocations.map((hash, index) => {
        return (
          <div key={ index }>
            <button className="select-entitlement-btn btn btn-outline-grey text-dark rounded-pill py-2 px-6 mb-4 w-em-45" onClick={() => { setLocation(hash) }}>
              <div className="text-left font-size-7">
                { hash.name }
              </div>
            </button>
          </div>
        )
      });

      setPanels(panelLocations);
    }
  }, [locationIds, locationList]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!!location) {
      localStorage.setItem('practice_location', JSON.stringify(location));
      window.location.replace('/eb/');
    }
  }, [location]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div id="main-content-target">
      <h2 className="text-danger">Employee Benefits</h2>

      <Modal show={ show } onHide={ handleClose } keyboard={ false } size="lg" centered backdrop="static">
        <Modal.Header className="d-block">
          <h3 className="text-center">Which Practice Location Are You In Today?</h3>
        </Modal.Header>

        <Modal.Body className="d-block text-center">
          <div className="conditional-display" displayed={ (!displayError).toString() }>
            <p className="text-center text-grey mb-10">Select your current practice location.</p>
            { panels }
          </div>

          <div className="conditional-display" displayed={ displayError.toString() }>
            <p className="text-center text-grey mb-10">No practice locations found. <br/>Please contact your administrator to rectify this issue.</p>

            <button className="btn btn-danger text-white rounded-pill py-3 px-20" onClick={ logOut } >
              Log Out
            </button>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default SelectLocation;